export default __webpack_public_path__ + "static/media/lock2.d9695bd6.svg";